'use client';

import type { SignupButtonProps } from './signup-button';
import React from 'react';
import dynamic from 'next/dynamic';
import SignupLink from './signup-link';

// This currently is not working. Webpack throws a runtime error when trying to load the dynamic import.
// It has something to do with the use of Context and State in the ModalProvider, though the error appears
// to be raised by an attempt to import the React JSX runtime in that file.
const DynamicSignupButton = dynamic<SignupButtonProps>(
  () => import('@/components/ui/signup-button/signup-button'),
  {
    // ssr: false,
    loading: () => <SignupLink />,
  }
);

export default function SignupButton(props: SignupButtonProps = {}) {
  return <DynamicSignupButton {...props} />;
}
